import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/Card';
import { Input } from '../components/Input';
import { Textarea } from '../components/Textarea';
import { ARWMButton } from '../components/ARWMButton';
import { Briefcase, MapPin, Clock } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
export function Emploi() {
  useSEO("Offres d'Emploi - ARWM | Carrières Restauration Marrakech", "Découvrez les opportunités de carrière dans les meilleurs restaurants de Marrakech. Postulez aux offres d'emploi des membres ARWM.");
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In production, this would send to rhgroupeld@gmail.com
    console.log('Form submitted:', formData);
    alert('Votre candidature a été envoyée avec succès !');
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };
  const jobs = [{
    title: 'Chef de Cuisine',
    restaurant: 'Restaurant membre ARWM',
    location: 'Guéliz, Marrakech',
    type: 'CDI',
    description: "Recherche chef de cuisine expérimenté pour restaurant gastronomique. Minimum 5 ans d'expérience."
  }, {
    title: 'Serveur / Serveuse',
    restaurant: 'Restaurant membre ARWM',
    location: 'Médina, Marrakech',
    type: 'CDI',
    description: "Restaurant traditionnel recherche serveur(se) avec excellente présentation et maîtrise du français et de l'anglais."
  }, {
    title: 'Commis de Cuisine',
    restaurant: 'Restaurant membre ARWM',
    location: 'Hivernage, Marrakech',
    type: 'CDD',
    description: 'Opportunité pour jeune diplômé en hôtellerie. Formation assurée par notre chef.'
  }];
  return <div className="w-full" data-id="element-292">
      {/* Hero */}
      <section className="py-32 px-4 bg-arwm-maroon" data-id="element-293">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-294">
          <h1 className="font-cormorant text-7xl font-bold text-white mb-6" data-id="element-295">
            Offres d'Emploi
          </h1>
          <p className="font-josefin text-xl text-arwm-cream max-w-3xl mx-auto" data-id="element-296">
            Découvrez les opportunités de carrière dans les meilleurs
            restaurants de Marrakech
          </p>
        </div>
      </section>

      {/* Job Listings */}
      <section className="py-20 px-4 bg-white" data-id="element-297">
        <div className="max-w-[1280px] mx-auto" data-id="element-298">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-299">
            Opportunités
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-300">
            Postes Disponibles
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-301">
            {jobs.map((job, index) => <Card key={index} data-id="element-302">
                <CardHeader data-id="element-303">
                  <div className="flex items-center text-arwm-maroon mb-2" data-id="element-304">
                    <Briefcase className="w-5 h-5 mr-2" data-id="element-305" />
                    <span className="font-josefin text-sm font-semibold" data-id="element-306">
                      {job.type}
                    </span>
                  </div>
                  <CardTitle className="font-cormorant text-2xl" data-id="element-307">
                    {job.title}
                  </CardTitle>
                </CardHeader>
                <CardContent data-id="element-308">
                  <p className="font-josefin text-arwm-dark-text font-semibold mb-2" data-id="element-309">
                    {job.restaurant}
                  </p>
                  <div className="flex items-center text-arwm-dark-text mb-4" data-id="element-310">
                    <MapPin className="w-4 h-4 mr-2" data-id="element-311" />
                    <span className="font-josefin text-sm" data-id="element-312">{job.location}</span>
                  </div>
                  <p className="font-josefin text-arwm-dark-text mb-4" data-id="element-313">
                    {job.description}
                  </p>
                  <a href="#candidature" className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-314">
                    Postuler →
                  </a>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Spontaneous Application Form */}
      <section id="candidature" className="py-20 px-4 bg-arwm-light-gray" data-id="element-315">
        <div className="max-w-[1280px] mx-auto" data-id="element-316">
          <div className="max-w-3xl mx-auto" data-id="element-317">
            <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-318">
              Postulez
            </p>
            <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-6 text-center" data-id="element-319">
              Candidature Spontanée
            </h2>
            <p className="font-josefin text-lg text-arwm-dark-text mb-12 text-center" data-id="element-320">
              Vous ne trouvez pas l'offre qui vous correspond ? Envoyez-nous
              votre candidature spontanée.
            </p>

            <Card data-id="element-321">
              <CardContent className="p-8" data-id="element-322">
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-323">
                  <div data-id="element-324">
                    <label htmlFor="name" className="block font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-325">
                      Nom complet *
                    </label>
                    <Input id="name" type="text" required value={formData.name} onChange={e => setFormData({
                    ...formData,
                    name: e.target.value
                  })} placeholder="Votre nom" data-id="element-326" />
                  </div>

                  <div data-id="element-327">
                    <label htmlFor="email" className="block font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-328">
                      Email *
                    </label>
                    <Input id="email" type="email" required value={formData.email} onChange={e => setFormData({
                    ...formData,
                    email: e.target.value
                  })} placeholder="votre.email@exemple.com" data-id="element-329" />
                  </div>

                  <div data-id="element-330">
                    <label htmlFor="phone" className="block font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-331">
                      Téléphone *
                    </label>
                    <Input id="phone" type="tel" required value={formData.phone} onChange={e => setFormData({
                    ...formData,
                    phone: e.target.value
                  })} placeholder="06 XX XX XX XX" data-id="element-332" />
                  </div>

                  <div data-id="element-333">
                    <label htmlFor="message" className="block font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-334">
                      Message / Présentation *
                    </label>
                    <Textarea id="message" required value={formData.message} onChange={e => setFormData({
                    ...formData,
                    message: e.target.value
                  })} placeholder="Présentez-vous et décrivez votre parcours professionnel..." rows={6} data-id="element-335" />
                  </div>

                  <div className="bg-arwm-light-gray p-4" data-id="element-336">
                    <p className="font-josefin text-sm text-arwm-dark-text" data-id="element-337">
                      <strong data-id="element-338">Note :</strong> Veuillez joindre votre CV par
                      email à{' '}
                      <a href="mailto:rhgroupeld@gmail.com" className="text-arwm-maroon font-semibold hover:underline" data-id="element-339">
                        rhgroupeld@gmail.com
                      </a>{' '}
                      en mentionnant votre nom dans l'objet du message.
                    </p>
                  </div>

                  <ARWMButton type="submit" className="w-full" data-id="element-340">
                    Envoyer ma candidature
                  </ARWMButton>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>;
}